import React from "react";
import { useDispatch, useSelector } from "react-redux";
import TrikeSosCard from "../TripDetails/components/TrikeSosCard";
import { batterySwapSteps } from "../TripDetails/constants";
import { trikeRepairSteps } from "../TripDetails/TrikeRepairDrawer";
import { updateTrips } from "../../../Redux/Slices/trips.slice";

const TripRequests = () => {
  const {
    batterySwapRequestModal,
    activeBreakdownRequest,
    activeBatterySosRequest,
  } = useSelector((state) => state.trips);

  const getBatterySwapStep = () => {
    if (batterySwapRequestModal?.visible) {
      return batterySwapRequestModal?.data?.step;
    }
    if (activeBatterySosRequest) {
      const { status } = activeBatterySosRequest;
      if (status === 1) return batterySwapSteps.REQUEST_CREATED;
      if (status === 2 || status === 4 || status === 8)
        return batterySwapSteps.REQUEST_ACCEPTED_AGENT;
      if (status === 5) return batterySwapSteps.REQUEST_COMPLETED_AGENT;
      if (status === 3 || status === 7)
        return batterySwapSteps.REQUEST_REJECTED;
    }
    return null;
  };

  const step = getBatterySwapStep();

  const getBatterySosBadges = () => {
    if (!activeBatterySosRequest) return [];
    const { status } = activeBatterySosRequest;
    if (status === 1) {
      return [{ text: "Requested", type: "warning" }];
    }
    if (status === 3 || status === 7) {
      return [{ text: "Rejected", type: "alert" }];
    }
    if (status === 5) {
      return [
        { text: "Deliver via Agent", type: "success" },
        { text: "Completed", type: "primary" },
      ];
    }
    return [
      { text: "Deliver via Agent", type: "success" },
      { text: "Assigned", type: "success" },
    ];
  };

  const batteryBadges = getBatterySosBadges();

  const statusToStep = {
    1: trikeRepairSteps.REQUEST_CREATED, // PENDING
    2: trikeRepairSteps.REQUEST_ACCEPTED, // ACCEPTED
    3: trikeRepairSteps.REQUEST_REJECTED, // REJECTED
    4: trikeRepairSteps.REQUEST_ACCEPTED, // IN_PROGRESS
    5: trikeRepairSteps.REQUEST_COMPLETED, // COMPLETED
    6: trikeRepairSteps.REPLACEMENT_REQUESTED, // REPLACEMENT_REQUESTED
    7: trikeRepairSteps.REQUEST_COMPLETED, // CLOSED
  };

  const trikeStep = activeBreakdownRequest
    ? statusToStep[activeBreakdownRequest.status] ??
      trikeRepairSteps.REQUEST_CREATED
    : null;

  const getTrikeRepairBadges = (currentStep) => {
    if (currentStep === trikeRepairSteps.REQUEST_COMPLETED) {
      return [{ text: "Completed", type: "primary" }];
    }
    if (currentStep === trikeRepairSteps.REQUEST_ACCEPTED) {
      return [{ text: "Assigned", type: "success" }];
    }
    if (currentStep === trikeRepairSteps.REPLACEMENT_REQUESTED) {
      return [{ text: "Replacement Requested", type: "warning" }];
    }
    if (currentStep === trikeRepairSteps.REQUEST_REJECTED) {
      return [{ text: "Rejected", type: "alert" }];
    }
    return [{ text: "Requested", type: "warning" }];
  };

  const dispatch = useDispatch();

  return (
    <div className="flex flex-col gap-y-6">
      {activeBatterySosRequest?.id && step !== null && (
        <TrikeSosCard
          title="1 Battery Swap Request"
          badges={batteryBadges}
          onClick={() => {
            dispatch(
              updateTrips({
                key: "batterySwapRequestModal",
                value: {
                  visible: true,
                  data: { step },
                },
              }),
            );
          }}
        />
      )}
      {activeBreakdownRequest?.id && trikeStep !== null && (
          <TrikeSosCard
            title="1 Trike Repair Request"
            badges={getTrikeRepairBadges(trikeStep)}
            onClick={() => {
              dispatch(
                updateTrips({
                  key: "trikeRepairModal",
                  value: {
                    visible: true,
                    data: { step: trikeStep },
                  },
                }),
              );
            }}
          />
        )}
    </div>
  );
};

export default TripRequests;
